import React, { useState } from "react";

const ForgetPassword = () => {
  const [activeTab, setActiveTab] = useState("mobile");
  return (
    <>
      <section className="auth-page-bg py-8 md:py-24 relative">
        <div className="container">
          <div className="flex items-center justify-center">
            <div className="max-w-[485px] w-full text-center">
              {/* Title and Subtitle */}
              <h1 className="web-h2 text-gray-950 mb-2">
                Forgot Your Password?
              </h1>
              <p className="text-gray-600 web-body-sm mb-8">
                Enter your registered email
              </p>

              {/* Login Card Container */}
              <div className="bg-white p-[15px] md:p-[20px] rounded-[20px] shadow-[0px_1px_14px_rgba(79,77,77,0.08)]">
                {/* Form Content */}
                <form className="flex flex-col gap-[10px] text-left">
                  <>
                    <label
                      htmlFor="email"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="custom-input"
                      placeholder="Enter email"
                      required
                    />
                  </>
                  {/* Log In Button (Matches the golden/yellow color) */}
                  <button
                    type="submit"
                    className="custom-btn custom-btn-primary w-full mt-[15px]"
                  >
                    Continue
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 hidden xl:block">
          <img src="/images/shape3.png" alt="shape" />
        </div>
        <div className="absolute bottom-0 right-0 hidden xl:block">
          <img src="/images/shape4.png" alt="shape" />
        </div>
      </section>
    </>
  );
};

export default ForgetPassword;
